import Swal from 'sweetalert2';

export const getEventPin = async () => {
    let pin = localStorage.getItem('EVENT_CHECKIN_PIN');
    
    if (!pin) {
        const { value: enteredPin } = await Swal.fire({
            title: 'Enter Event PIN',
            input: 'password',
            inputLabel: 'Volunteer Passcode',
            inputPlaceholder: 'Enter your 4-6 digit PIN',
            allowOutsideClick: false,
            allowEscapeKey: false,
            inputValidator: (value) => {
                if (!value) {
                    return 'You need to write something!';
                }
            }
        });

        if (enteredPin) {
            pin = enteredPin;
            localStorage.setItem('EVENT_CHECKIN_PIN', pin);
        }
    }
    
    return pin;
};

export const clearEventPin = () => {
    localStorage.removeItem('EVENT_CHECKIN_PIN');
};

export const handlePinAuthError = async () => {
    clearEventPin();
    await Swal.fire('Unauthorized', 'Invalid Event PIN. Please try again.', 'error');
    window.location.reload();
};
